module.exports = __webpack_public_path__ + "img/logo with name.925449ac.png";